import { Action as RFRAction } from 'redux-first-router';

import { AppMode } from 'uf/app/modes';
import { ROUTE_EXPLORE_NEW } from 'uf/explore/ActionTypes';
import { Query } from 'uf/routing';
import { makeRoutingActionType } from 'uf/routing/actions';

export function setExploreNewRoute(
  namespace: string,
  projectKey: string,
  mapOnly: boolean = false,
  layerListNotVisible: boolean = false,
  mode?: AppMode,
  flags?: string[],
): RFRAction {
  const query: Query = {};
  if (mapOnly) {
    query.maponly = '1';
  } else if (mode) {
    query.mode = mode;
  } else if (layerListNotVisible) {
    query.layerListNotVisible = '1';
  }
  return {
    type: makeRoutingActionType(ROUTE_EXPLORE_NEW),
    query,
    payload: {
      namespace,
      projectKey,
    },
  };
}
